import { Box, type BoxProps, Button, Typography, styled } from "@mui/material";
import { rem } from "polished";
import React from "react";

import { Icon } from "src/components";
import { useDeviceWidth } from "src/hooks";

const StyledCard = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${(props) => props.theme.palette.gray.credentialsCardBackground};
  border: 1px solid ${(props) => props.theme.palette.gray.background};
  border-radius: ${(props) => props.theme.spacing(0.5)};
  padding: ${(props) => props.theme.spacing(2)};
  margin: ${(props) => props.theme.spacing(4)} ${(props) => props.theme.spacing(0)};

  ${(props) => props.theme.breakpoints.up("sm")} {
    margin: ${(props) => props.theme.spacing(4)} ${(props) => props.theme.spacing(2)};
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(4)};
    margin: ${(props) => props.theme.spacing(4)};
  }
`;

const StyledTitle = styled(Typography)`
  font-size: ${rem(16)};
  padding: ${(props) => props.theme.spacing(2)};
  color: ${(props) => props.theme.palette.primary.main};
  font-weight: bold;
`;

const StyledInput = styled(Box)`
  width: 100%;
  padding: ${(props) => props.theme.spacing(2)};
  background-color: ${(props) => props.theme.palette.gray.background};
  border-radius: ${(props) => props.theme.spacing(0.5)};
  text-align: center;
  margin: ${(props) => props.theme.spacing(4)} ${(props) => props.theme.spacing(0)};
  ${(props) => props.theme.breakpoints.up("md")} {
    margin: ${(props) => props.theme.spacing(4)};
  }
`;

interface Props extends BoxProps {
  login?: string | null;
  handleOpen: () => void;
}

export const Credentials = ({ login, handleOpen, ...boxProps }: Props) => {
  const { isMobile } = useDeviceWidth();
  return (
    <Box
      {...boxProps}
      sx={{ display: "flex", flexDirection: isMobile ? "column" : "row", ...boxProps.sx }}
    >
      <StyledCard>
        <Icon name="user" size={50} />
        <StyledTitle>Votre adresse e-mail de connexion :</StyledTitle>

        <StyledInput>
          <Typography>{login || "Non disponible"}</Typography>
        </StyledInput>

        <Button disabled variant="contained">
          Modifier
        </Button>
      </StyledCard>

      <StyledCard>
        <Icon name="lock" size={50} />
        <StyledTitle>Votre mot de passe actuel :</StyledTitle>

        <StyledInput>
          <Typography>⁎ ⁎ ⁎ ⁎ ⁎ ⁎ ⁎ ⁎ ⁎ ⁎</Typography>
        </StyledInput>

        <Button
          data-cy="profile-credentials-password-button"
          variant="contained"
          onClick={handleOpen}
        >
          Modifier mon mot de passe
        </Button>
      </StyledCard>
    </Box>
  );
};
